import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'
import { Search } from '@/shared/components/molecules/Search/Search'

import RequestCustomIntegrationButton from './RequestCustomIntegrationButton'

interface IntegrationsHeaderProps {
	searchValue: string
	onSearchChange: (value: string) => void
	activeTab: 'integrations' | 'addons'
	onTabChange: (tab: 'integrations' | 'addons') => void
}

const IntegrationsHeader: React.FC<IntegrationsHeaderProps> = ({
	searchValue,
	onSearchChange,
	activeTab,
	onTabChange,
}) => {
	const { t } = useTranslation('common')

	return (
		<div className="space-y-6 mb-4 md:m-0">
			{/* Desktop: description only (title is in PageLayout bar, same as Zone details) */}
			<div className="space-y-2 hidden md:block">
				<p className="text-sm text-muted-foreground">
					{t('integrations.description')}
				</p>
			</div>

			<div className="space-y-6 hidden md:block">
				<div className="flex items-center gap-4 justify-between">
					<Search
						value={searchValue}
						onChange={onSearchChange}
						placeholder="Search"
						className="max-w-md"
					/>

					<RequestCustomIntegrationButton />
				</div>

				<div className="flex justify-center items-center gap-1 p-1 bg-background border dark:border-none rounded-full w-fit">
					<Button
						variant="ghost"
						onClick={() => onTabChange('integrations')}
						className={`px-4 rounded-full text-sm font-medium transition-colors ${
							activeTab === 'integrations'
								? 'bg-muted text-foreground'
								: 'text-muted-foreground'
						}`}
					>
						{t('navigation.integrations')}
					</Button>
					<Button
						variant="ghost"
						onClick={() => onTabChange('addons')}
						className={`px-4 rounded-full text-sm font-medium transition-colors ${
							activeTab === 'addons'
								? 'bg-muted text-foreground'
								: 'text-muted-foreground'
						}`}
					>
						{t('integrations.addons.title')}
					</Button>
				</div>
			</div>
			<div className="space-y-6 block md:hidden">
				<div className="flex justify-around items-center gap-1 p-1 bg-background border dark:border-none rounded-full w-full">
					<Button
						variant="ghost"
						onClick={() => onTabChange('integrations')}
						className={`w-full rounded-full text-sm font-medium transition-colors ${
							activeTab === 'integrations'
								? 'bg-muted text-foreground'
								: 'text-muted-foreground'
						}`}
					>
						{t('navigation.integrations')}
					</Button>
					<Button
						variant="ghost"
						onClick={() => onTabChange('addons')}
						className={`w-full rounded-full text-sm font-medium transition-colors ${
							activeTab === 'addons'
								? 'bg-muted text-foreground'
								: 'text-muted-foreground'
						}`}
					>
						{t('integrations.addons.title')}
					</Button>
				</div>

				<div className="flex flex-col  items-center gap-4 justify-between">
					<Search
						value={searchValue}
						onChange={onSearchChange}
						placeholder="Search"
						className="w-full mb-2"
					/>

					<RequestCustomIntegrationButton />
				</div>
			</div>
		</div>
	)
}

export default IntegrationsHeader
